import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { putKjoretoyMerke } from "../../../../actions/kjoretoyMerkerActions";
import {
  IsValidated,
  onChangeValidation,
} from "../../../../utils/validationUtils";
import ModalGeneric from "../../../Common/ModalGeneric";
import UpdateOpenModal from "../../CreateModals/UpdateOpenModal";
import KjoretoyMerkerForm from "../../KjoretoyMerkerForm";

const rules = {
  kode: "required;minLength=1;maxLength=50",
  merke: "required;minLength=1;maxLength=50",
};

function KjoretoyMerkerModal({ kjoretoyMerke }) {
  const dispatch = useDispatch();
  const initState = () => ({
    open: false,
    submitButtonText: "Lagre",
    id: kjoretoyMerke.id,
    kode: kjoretoyMerke.kode,
    merke: kjoretoyMerke.merke,
    validationError: {},
  });
  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  useEffect(() => {
    setState((s) => ({
      ...s,
      kode: kjoretoyMerke.kode,
      merke: kjoretoyMerke.merke,
    }));
  }, [kjoretoyMerke]);

  const closeModal = () => setState(initState());

  const isFormValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePut = () => {
    update({ submitButtonText: "Lagrer..." });
    dispatch(
      putKjoretoyMerke({ id: state.id, kode: state.kode, merke: state.merke }),
    )
      .then(closeModal)
      .catch(() => update({ submitButtonText: "Lagre" }));
  };

  const saveAndClose = () => {
    if (isFormValid()) handlePut();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const draft = { ...state, [name]: value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <ModalGeneric
      modalTitle="Rediger kjøretøymerke"
      open={state.open}
      closeModal={closeModal}
      openModal={() => update({ open: true })}
      OpenModalComponent={UpdateOpenModal}
      submit={saveAndClose}
      submitButtonText={state.submitButtonText}
    >
      <KjoretoyMerkerForm
        kode={state.kode}
        merke={state.merke}
        handleChange={handleChange}
        validationError={state.validationError}
        actionType="update"
      />
    </ModalGeneric>
  );
}

export default KjoretoyMerkerModal;
